import { User }          from '@app/modules/user/models/user.model';
import { IManageTenant } from '@shared/content-sections/manage-tenant/manage-tenant.model';
import { ManagedObject } from '@shared/models/managed-object.model';

export interface ICurrentUserState {
	isAuthenticated: boolean;
	profile: object;
	roles: string[];
	isLoading: boolean;
	error: string;
	currentUserId: string;
	manageTenant: IManageTenant;
	user: User;
	tenantId: string;
	managedObject: ManagedObject;
}

export const initialState: ICurrentUserState = {
	isAuthenticated: false,
	profile: null,
	roles: [],
	isLoading: false,
	error: null,
	currentUserId: null,
	manageTenant: null,
	user: null,
	tenantId: null,
	managedObject: null
};
